module.exports = __webpack_public_path__ + "img/helpbook.7ed3123d.png";